import { getChildColumns } from "@/modules/reports/billables/status/columns";
export { getChildColumns };

export const getChildData = (row, status) => {
  const contacts = row.contacts || [];
  const billables = [];

  contacts.forEach((contact) => {
    const projects = contact.projects || [];
    projects.forEach((project) => {
      const jobs = project.jobs || [];
      jobs.forEach((job) => {
        const jobBillables = job.billables || [];
        jobBillables.forEach((billable) => {
          billables.push({
            ...billable,
            job,
            project,
          });
        });
      });
    });
  });

  // Sort billables based on status
  const sortByField = (field) => {
    return billables.sort((a, b) => {
      const dateA = a[field] ? new Date(a[field]) : new Date(0);
      const dateB = b[field] ? new Date(b[field]) : new Date(0);
      return dateA - dateB; // Ascending order
    });
  };

  switch (status) {
    case "contracted":
    case "pending_invoice":
    case "cancelled":
    case "all":
    case "extended":
      return sortByField("billing_date");
    case "billed":
      return sortByField("forecast_date");
    case "collected":
      return sortByField("collected_date");
    case "advance":
      return sortByField("invoice_date");
    default:
      return billables;
  }
};

export const getBillableFiltersFromCompanyFilters = (filters) => {
  const billableFilters = {};

  const billablesNode = filters?.contacts?.projects?.jobs?.billables;
  if (billablesNode) {
    if (billablesNode.status) billableFilters.status = billablesNode.status;
    if (billablesNode.billing_date)
      billableFilters.billing_date = billablesNode.billing_date;
    if (billablesNode.collected_date)
      billableFilters.collected_date = billablesNode.collected_date;
    if (billablesNode.due_date)
      billableFilters.due_date = billablesNode.due_date;
    if (billablesNode.invoice_date)
      billableFilters.invoice_date = billablesNode.invoice_date;
    if (billablesNode.date_updated)
      billableFilters.date_updated = billablesNode.date_updated;
  }

  const jobsNode = filters?.contacts?.projects?.jobs;
  if (jobsNode?.type) {
    billableFilters.job = { ...billableFilters.job, type: jobsNode.type };
  }

  const projectsNode = filters?.contacts?.projects;
  if (projectsNode) {
    const projectFilters = {};
    if (projectsNode.id) projectFilters.id = projectsNode.id;
    
    if (projectsNode.sales_coordinator)
      projectFilters.sales_coordinator = projectsNode.sales_coordinator;
    
    if (projectsNode.account_manager)
      projectFilters.account_manager = projectsNode.account_manager;

    if (Object.keys(projectFilters).length > 0) {
      billableFilters.job = {
        ...billableFilters.job,
        project: { ...billableFilters.job?.project, ...projectFilters },
      };
    }
  }

  if (filters?.id) {
    billableFilters.job = {
      ...billableFilters.job,
      project: {
        ...billableFilters.job?.project,
        client: {
          company_id: filters.id,
        },
      },
    };
  }

  return billableFilters;
};
